<template>
    <booking-layout :fo_config="fo_config" :settingsConfig="settingsConfig" :step="current_step" >
        <select-prestation v-if="(current_step == 1)" @submit="go_to_freetimeslot_selection($event)" @located="selected_location = $event" @agendaChanged="selected_agenda = $event"
                            :agendas="agendas" :prestations="prestations" :locations="locations" :fo_config="fo_config" :settingsConfig="settingsConfig">
        </select-prestation>
        <select-time-slot @submit="go_to_confirmation($event)" @back="go_to_prestation_selection()" v-if="(current_step == 2)"
                          :prestations="store.selected_prestations" :locations="locations" :agendas="agendas"
                          :agenda="store.selected_agenda" :location="store.selected_location"
                          :config="config" :fo_config="fo_config" :settingsConfig="settingsConfig"
            >
        </select-time-slot>
        <validate-appointment @submit="submit(prestation)" @back="go_to_freetimeslot_selection(selected_prestations)" v-if="(current_step == 3)"
                          :rdv_data="rdv_data" :prestations="store.selected_prestations" :locations="locations"
                          :agenda="store.selected_agenda" :location="store.selected_location"
                          :config="config" :fo_config="fo_config" :settingsConfig="settingsConfig" :rdv="rdv"
            >
        </validate-appointment>
    </booking-layout>
</template>

<script>
import BookingLayout from './BookingLayout.vue';
import SelectPrestation from './SelectPrestation.vue';
import SelectTimeSlot from './SelectTimeSlot.vue';
import ValidateAppointment from './ValidateAppointment.vue';
import { BookingStore } from '../Stores/BookingStore';

export default {
    name: 'Booking',
    props: ['agendas', 'config', 'locations', 'prestations', 'group_sizes', 'settingsConfig', 'fo_config', 'price', 'rdv'],
    components: { BookingLayout, SelectPrestation, SelectTimeSlot, ValidateAppointment },

    data() {
        return {
            store: BookingStore,
            step: 1,
            rdv_data: null,
            // selected_prestations: [],
            // selected_location: null,
            // selected_agenda: null,

        }
    },

    computed: {
        current_step() {
            return BookingStore.current_step;
        }
    },

    methods: {
        go_to_prestation_selection() {
            console.log('Booking store selected', BookingStore.selected_prestations);
            BookingStore.set_step(1);
        },
        go_to_freetimeslot_selection(prestations) {
            this.selected_prestations = prestations;
            console.log('Booking select freetime', BookingStore.selected_prestations);
            BookingStore.set_step(2);
        },
        go_to_confirmation(rdv_data) {
            this.rdv_data = rdv_data;
            console.log("booking go_to_confirmation ",this.rdv_data,rdv_data);
            BookingStore.set_step(3);
        },
        submit() {

        }
    },

    mounted() {
        this.step = 1
        // console.log('booking locations', this.locations);
        // console.log('BookingStore rdvToModify', this.store.rdvToModify);
    }

}

</script>